import * as React from 'react';
import { format } from 'timeago.js';
const twoDigitsDateTime = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
};
export const FormattedDate = ({ value, className }) => {
    if (!value)
        return null;
    const formatted = value.toLocaleDateString(undefined, twoDigitsDateTime);
    const relative = format(value);
    return (React.createElement("p", { className: className },
        relative,
        " \u00B7 ",
        formatted));
};
//# sourceMappingURL=FormattedDate.js.map